<template>
    <div class="sm:col-span-12 flex flex-wrap text-gray-700 -mt-4">
        <div class="py-2 mr-2 text-sm">
            Codes
        </div>
        <div @click="insertCode('{member-first}')" class="uppercase border border-gray-500 p-1 mr-2 place-self-center whitespace-no-wrap text-center text-xs cursor-pointer">
            Member First
        </div>
        <div @click="insertCode('{member-last}')" class="uppercase border border-gray-500 p-1 mr-2 place-self-center whitespace-no-wrap text-center text-xs cursor-pointer">
            Member Last
        </div>
        <div @click="insertCode('{supplier}')" class="uppercase border border-gray-500 p-1 mr-2 place-self-center whitespace-no-wrap text-center text-xs cursor-pointer">
            Supplier Name
        </div>
        <div @click="insertCode('{application-date}')" class="uppercase border border-gray-500 p-1 mr-2 place-self-center whitespace-no-wrap text-center text-xs cursor-pointer">
            Application Date
        </div>
        <div @click="insertCode('{date}')" class="uppercase border border-gray-500 p-1 mr-2 place-self-center whitespace-no-wrap text-center text-xs cursor-pointer">
            Date
        </div>
        <div @click="insertCode('{amount}')" class="uppercase border border-gray-500 p-1 mr-2 place-self-center whitespace-no-wrap text-center text-xs cursor-pointer">
            Amount
        </div>
        <div @click="insertCode('{supplier-address}')" class="uppercase border border-gray-500 p-1 mr-2 place-self-center whitespace-no-wrap text-center text-xs cursor-pointer">
            Supplier Address
        </div>
        <div @click="insertCode('{supplier-phone}')" class="uppercase border border-gray-500 p-1 mr-2 place-self-center whitespace-no-wrap text-center text-xs cursor-pointer">
            Supplier Phone
        </div>
        <div @click="insertCode('{application-id}')" class="uppercase border border-gray-500 p-1 mr-2 place-self-center whitespace-no-wrap text-center text-xs cursor-pointer">
            Application ID
        </div>
    </div>
</template>

<script>
export default {
    name: 'SmsInsertCodes',
    props: {
        input: { required: true },
        output:  { required: true }
    },
    methods: {
        insertCode(code){
            this.$emit('insert', { code: code, input: this.input, output: this.output })
        }
    }
}
</script>

<style scoped>

</style>
